import SanitizeUrl from "@/utils/sanitizeUrl";

export default function openWindow(
  url: string,
  target: string,
  windowFeatures: string
): void {
  globalThis.open(SanitizeUrl(url), target, windowFeatures);
}
